// The path without the locale prefix: "/fa/x/" -> "/x/", "/fa" -> "/".
// Only a whole leading segment is removed. `pathname.replace("/fa", "")` also hit the middle of a path
// ("/blogs/category/fashion-news/" -> "/blogs/category/shion-news/"), so the page lookup came back found:false.
export const strip_locale_prefix = (pathname = "", locale = "") => {
	if (!pathname || !locale) return pathname;
	const prefix = `/${locale}`;
	if (pathname === prefix) return "/";
	return pathname.startsWith(`${prefix}/`) ? pathname.slice(prefix.length) : pathname;
};
